/** ***********************************************************************
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

import React from 'react';
import { observer } from 'mobx-react';
import PDPHeader from './pdpHeader';
import PDPLeftPanel from './leftPanel';
import PDPRightPanel from './rightPanel';
import './pdp.scss';
import { PDPAnalytics } from '../../../analytics';

export default observer(
    ({
        PDPDataObject, appsList, appsPanelSkeleton, layouts, appConfig,
        sectionId,
    }) => {
        PDPAnalytics.initAnalyticObject(PDPDataObject.app, sectionId);
        return (
            [
                <PDPHeader
                    key="pdp-header"
                    headerData={PDPDataObject}
                />,
                <div key="outerDivPdp" className="outerDivPdp">
                    <div key="pdp-body" className="pdp-body">
                        <PDPLeftPanel
                            PDPDataObject={PDPDataObject}
                            appConfig={appConfig}
                            appsPanelSkeleton={appsPanelSkeleton}
                            layouts={layouts} />
                        <PDPRightPanel
                            PDPDataObject={PDPDataObject}
                            appsList={appsList}
                            appsPanelSkeleton={appsPanelSkeleton} />
                    </div>
                </div>,
                <div className="banner-video-modal-target" />,
            ]
        );
    }
);
